import request from "./request";

const calculate = async (data: any) => {
  const res = await request({
    url: "/v1/public/cart/quote",
    method: "post",
    data,
  });
  return res.data;
};

export default { calculate };
